import { useTranslation } from '../../lib/i18n';
import List from '../common/list';

export const hasIncluded = (product) =>
  product.rotweine?.length > 0 ||
  product.weissweine?.length > 0 ||
  product['3er']?.length > 0 ||
  product['6er']?.length > 0 ||
  product.weine?.length > 0;

const Included = ({ product, className = '', title }) => {
  const { t } = useTranslation();
  if (!hasIncluded(product)) {
    return <></>;
  }
  if (!title) {
    title = t('includedWine');
  }

  return (
    <div className={className}>
      <h2 className='h1 mb-10'>{title}</h2>
      {product.rotweine?.length > 0 && (
        <>
          <h4 className='mb-8 mt-12'>{t('redwiens')}</h4>
          <List items={product.rotweine} listName='included' />
        </>
      )}
      {product.weissweine?.length > 0 && (
        <>
          <h4 className='mb-8 mt-12'>{t('whitewiens')}</h4>
          <List
            className='mb-8'
            items={product.weissweine}
            listName='included'
          />
        </>
      )}
      {product.weine?.length > 0 && (
        <>
          <List
            className='mb-8 mt-12'
            items={product.weine}
            listName='included'
          />
        </>
      )}
      {product['3er']?.length > 0 && (
        <>
          <h4 className='mb-8 mt-12'>{t('packages_3er')}</h4>
          <List className='mb-8' items={product['3er']} listName='included' />
        </>
      )}
      {product['6er']?.length > 0 && (
        <>
          <h4 className='mb-8 mt-12'>{t('packages_6er')}</h4>
          <List className='mb-8' items={product['6er']} listName='included' />
        </>
      )}
    </div>
  );
};

export default Included;
